import { addPrefixToRoutes, addWildcardToRoutes, useNavigate, UseNavigateOptions } from '@melio/ar-domain';
import { isString, isUndefined } from 'lodash';

const Paths = {
  Invoices: 'invoices',
  Estimates: 'estimates',
  Customers: 'customers',
};

type DashboardFlowPathsResult = {
  RedirectPaths: typeof Paths;
  Paths: typeof Paths;
  DefaultPath: string;
  goToCustomersDashboard: VoidFunction;
  goToInvoicesDashboard: (searchTerm?: string) => void;
};

export function useDashboardFlowNavigation(options?: UseNavigateOptions): DashboardFlowPathsResult;
export function useDashboardFlowNavigation<T extends string>(
  prefix: T,
  options?: UseNavigateOptions
): DashboardFlowPathsResult;
export function useDashboardFlowNavigation<T extends string | never>(
  arg1?: T | UseNavigateOptions,
  arg2?: UseNavigateOptions
) {
  let prefix: T | undefined = undefined;
  let options: UseNavigateOptions | undefined;

  if (isString(arg1)) {
    prefix = arg1;
    options = arg2;
  } else {
    options = arg1;
  }

  const TargetPaths = addPrefixToRoutes(Paths, prefix);
  const navigate = useNavigate(options);

  return {
    RedirectPaths: TargetPaths,
    Paths: addWildcardToRoutes(TargetPaths),
    DefaultPath: TargetPaths.Invoices,
    goToCustomersDashboard: () => navigate(TargetPaths.Customers),
    goToInvoicesDashboard: (searchTerm?: string) =>
      navigate(TargetPaths.Invoices, isUndefined(searchTerm) ? undefined : { queryParams: { searchTerm } }),
  };
}
